export default __webpack_public_path__ + "static/media/icon_checkmark-white.546ed693.svg";